import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import Button from '../../../../../components/Button';
import { AuthRoutes, Modules, PermissionActionsEnum, PermissionModulesEnum, RouteParamsTypes } from '../../../../../enums';
import { AuthContext } from '../../../../../contexts/AuthContext';
import { hasResourseAccess } from '../../../../../utils/methods';

const Header: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isSystemAdmin, permissions } = useContext(AuthContext);

  const hasAddAccess = hasResourseAccess(isSystemAdmin, permissions, {
    accessibleTo: [{ [PermissionModulesEnum.Products]: [PermissionActionsEnum.Add] }],
  });

  const handleAddClick = () => {
    navigate(Modules.products + AuthRoutes.products + RouteParamsTypes.add);
  };

  return (
    <div className="row mb-6">
      <div className="col-6">
        <h4 className="m-0 fw-bold">{t('products.list.pageTexts.header.title')}</h4>
        <p className="mb-0">{t('products.list.pageTexts.header.subTitle')}</p>
      </div>
      <div className="col-6 d-flex align-items-center justify-content-end">
        {hasAddAccess && (
          <Button
            className="btn btn-primary d-flex align-items-center"
            text={t('products.list.pageTexts.header.addNewButton')}
            onClick={handleAddClick}
          />
        )}
      </div>
    </div>
  );
};

export default Header;
